import {
    ExtendedErrorId,
    ExtendedFieldId,
    FieldContent,
    setCustomValidator,
    Validator,
} from '@sheerid/jslib';

export const graduationDateValidator = () => {
    const GraduationDateFieldId: ExtendedFieldId = 'graduationDate';
    const thisYear = new Date().getFullYear();
    const thisMonth = new Date().getMonth();
    const maxGraduationYear = thisYear + 4;

    const isValidGraduationDate = (value: any) => {
        const date = value.split('-');
        const year = Number.parseInt(date[0], 10) || undefined;
        const month = Number.parseInt(date[1], 10) || undefined;
        if (year === undefined || year < thisYear || year > maxGraduationYear) {
            return false;
        }
        if (month === undefined || (month < thisMonth && year === thisYear)) {
            return false;
        }
        return true;
    };

    const getGraduationDateValidationError: Validator = (value: FieldContent): ExtendedErrorId => {
        const invalidError: ExtendedErrorId = 'invalidGraduationDate';
        const missingError: ExtendedErrorId = 'graduationDateRequired';
        if (value === undefined || value === '') {
            return missingError;
        }
        if (!isValidGraduationDate(value)) {
            return invalidError;
        }
        return;
    };

    setCustomValidator(GraduationDateFieldId, getGraduationDateValidationError);
};
